import getIsSmallScreenWidth from '@libs/getIsSmallScreenWidth';

export default function getIsNarrowLayout() {
  return getIsSmallScreenWidth();
}
